import { Dropdown } from '../../components/ui/Dropdown';
import { ZoekBalk } from '../../components/ui/ZoekBalk';

export function FleetFilters({
  q,
  onQ,
  brandstof,
  onBrandstof,
  apk,
  onApk,
  count,
}: {
  q: string;
  onQ: (v: string) => void;
  brandstof: string;
  onBrandstof: (v: string) => void;
  apk: string;
  onApk: (v: string) => void;
  count: string;
}) {
  return (
    <ZoekBalk
      waarde={q}
      onWaarde={onQ}
      placeholder="Zoek op kenteken, bestuurder, merk of model…"
      ariaLabel="Wagenpark zoeken"
      aantal={count}
    >
      <Dropdown
        value={brandstof}
        onChange={onBrandstof}
        ariaLabel="Filter op brandstof"
        placeholder="Alle brandstof"
        options={[
          { value: '', label: 'Alle brandstof' },
          { value: 'Benzine', label: 'Benzine' },
          { value: 'Elektrisch', label: 'Elektrisch' },
          { value: 'Hybride', label: 'Hybride' },
        ]}
      />
      <Dropdown
        value={apk}
        onChange={onApk}
        ariaLabel="Filter op APK-status"
        placeholder="Alle APK-status"
        options={[
          { value: '', label: 'Alle APK-status' },
          { value: 'actie', label: 'Actie nodig / verlopen' },
          { value: 'ok', label: 'In orde' },
        ]}
      />
    </ZoekBalk>
  );
}
